import axios from 'axios'

export default {
    getOverviewOrder({commit}, params){
        return axios.post('/api/background/overview_order', params)
    },
    getOverviewCompany({commit}, params){
        return axios.post('/api/background/overview_company', params)
    },
    getEatSummaryList({commit}, params){
        return axios.post('/api/background/business_summary/order_by_time', params)
    },
    getFoodRankList({commit}, params){
        return axios.post('/api/background/business_summary/order_by_food', params)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions/survey.js